var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"form-slideshow-add"}},[_c('div',{staticClass:"vs-editor-canvas"},[_vm._l((_vm.items.slice().reverse()),function(each){return _c('Draggable',{key:each.id,attrs:{"item":each}})})],2),_vm._v(" "),_c('BaseFormLoading',{attrs:{"loading":_vm.loading.value}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eedf7b18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Player.vue
// module id = null
// module chunks = 